import { Link } from "react-router-dom";
import "../styles/TermsAndFAQ.css";

export default function TermsAndFAQ({ termsAccepted, setTermsAccepted }) {
  return (
    <div>
      <div className="booking__form--terms-item">
        <label htmlFor="terms">
          <input
            id="terms"
            name="terms"
            type="checkbox"
            aria-label="agree to terms and conditions"
            checked={termsAccepted}
            onChange={(e) => setTermsAccepted(e.target.checked)}
            required
          />{" "}
          I have read and agreed to the{" "}
          <Link
            to="/terms"
            target="_blank"
            rel="noopener noreferrer"
            className="booking__form--terms-link"
            aria-label="Open Terms and Conditions"
          >
            Terms and Conditions
          </Link>
        </label>
      </div>
      <div className="booking__form--terms-item">
        <Link
          to="/faq"
          target="_blank"
          rel="noopener noreferrer"
          className="booking__form--terms-link"
          aria-label="Open Frequently Asked Questions"
        >
          Frequently Asked Questions
        </Link>
      </div>
    </div>
  );
}
